<template>
  <div>
    <!-- <Header /> -->

    <confirmPopup
      v-if="popupwindow == true"
      :title="titlepass"
      @cancelClick="popupwindow = false"
      @confirmClick="deleteEvents(idpass)"
    />
    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />

    <div class="flex">
      <SideBar />

      <div
        class="w-[90%] mx-auto lg:w-full lg:mr-10 mt-10 rounded-3xl heightfix"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >
        <div class="flex h-full relative">
          <div class="relative rounded-3xl w-full">
            <div class="flex justify-end">
              <button
                @click="addevent = true"
                class="bg-[#047857] rounded-xl text-white px-4 py-1 mt-2 mr-6 z-40"
              >
                Add Class
              </button>
            </div>

            <vue-cal
              small
              ref="vuecal"
              events-on-month-view="short"
              active-view="month"
              :disable-views="['years', 'year', 'week']"
              :events="values"
              :on-event-click="onEventClick"
              class="rounded-3xl border-none absolute top-0 bottom-0 w-full"
            >
            </vue-cal>
          </div>
        </div>
      </div>

      <div
        v-if="addevent"
        class="fixed bg-primary bg-opacity-30 top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center"
      >
        <div
          class="lg:w-[40%] bg-white rounded-xl p-10 overflow-y-auto max-h-[600px]"
        >
          <div class="flex items-center justify-between">
            <h3 class="text-xl font-bold text-blues">Add Class</h3>
            <img
              src="@/assets/newd/close.png"
              class="cursor-pointer"
              alt=""
              @click="this.addevent = false"
            />
          </div>

          <div
            class="w-full mt-4 flex flex-col p-6 relative border border-gray-100 rounded-2xl"
          >
            <div class="w-full">
              <form
                ref="ScheduleEvent"
                @submit.prevent="scheduledate"
                class="flex flex-col gap-4 text-xs md:text-sm lg:text-base h-full"
              >
                <div
                  class="flex flex-col gap-2 w-full text-xs md:text-sm lg:text-base"
                >
                  <div class="w-full flex flex-col gap-2">
                    <label for="title" class="text-left">Title</label>
                    <input
                      id="meetingTitle"
                      type="text"
                      class="border border-gray-100 rounded text-xs md:text-sm lg:text-base py-2 px-2"
                      required
                    />
                  </div>
                  <div class="w-full flex flex-col gap-2">
                    <label for="duedate" class="text-left">Start Time</label>
                    <input
                      id="meetingDate"
                      type="datetime-local"
                      class="border border-gray-100 rounded text-xs md:text-sm lg:text-base py-2 px-2"
                      required
                    />
                  </div>

                  <div class="w-full flex flex-col gap-2">
                    <label for="duedate" class="text-left">End Time</label>
                    <input
                      id="meetingEndDate"
                      type="datetime-local"
                      class="border border-gray-100 rounded text-xs md:text-sm lg:text-base py-2 px-2"
                      required
                    />
                  </div>
                </div>
                <!-- <div class="flex flex-col w-full gap-2">
                  <label for="description" class="text-left">Description</label>
                  <textarea
                    id="description"
                    rows="3"
                    cols="10"
                    class="border border-gray-100 h-full rounded text-xs md:text-sm lg:text-base py-2 px-2"
                  />
                </div> -->
                <!-- <div class="flex flex-col w-full">
                  <label for="attachments" class="text-left">
                    Session duration
                  </label>
                  <input
                    id="duration"
                    type="number"
                    class="border border-gray-100 rounded text-xs md:text-sm lg:text-base py-2 px-2"
                    required
                  />
                </div> -->

                <!-- <div class="flex flex-col w-full">
                  <label for="attachments" class="text-left">
                    Learner limit
                  </label>
                  <input
                    id="studentLimit"
                    type="number"
                    class="border border-gray-100 rounded text-xs md:text-sm lg:text-base py-2 px-2"
                    required
                  />
                </div> -->

                <div class="flex flex-col w-full">
                  <label for="attachments" class="text-left">
                    Meeting URL
                  </label>
                  <div class="flex items-center gap-3 w-full">
                    <input
                      id="meetingUrl"
                      v-model="meetingUrl"
                      type="text"
                      class="border border-gray-100 rounded text-xs md:text-sm lg:text-base py-2 px-2 w-[80%]"
                      required
                    />

                    <div class="flex items-center gap-3">
                      <!-- -->

                      <button
                        v-if="isContainAccessToken"
                        @click="generateMeetingUrl()"
                        type="button"
                        id="Editurl"
                        class="rounded-xl text-sm p-2 whitespace-nowrap bg-blues hover:bg-[#18469d] cursor-pointer text-white"
                      >
                        Generate URL
                      </button>

                      <button
                        type="button"
                        id="Editurl"
                        class="rounded-xl text-sm p-2 whitespace-nowrap bg-blues hover:bg-[#18469d] cursor-pointer text-white"
                        @click="generateUrl()"
                        v-else
                      >
                        Config Settings
                      </button>

                      <!-- <button
                        type="button"
                        id="Editurl"
                        :disabled="disable_submit == true"
                        :class="
                          this.disable_submit == true
                            ? 'bg-gray-200 text-black cursor-not-allowed'
                            : 'bg-blues hover:bg-[#18469d] cursor-pointer text-white'
                        "
                        class="rounded-xl text-sm p-2 whitespace-nowrap"
                        @click="generateUrl()"
                      >
                        Generate URL
                      </button> -->
                      <!-- <img
                        v-if="disable_submit"
                        src="@/assets/loading.gif"
                        alt="loading"
                        class="w-6 h-6 object-contain"
                      /> -->
                    </div>
                    <!-- <button
                      type="button"
                      id="urlGenerator"
                      class="bg-blues p-2 text-sm text-white rounded-xl w-[20%]"
                      @click="generateUrl()"
                    >
                      Generate URL
                    </button> -->
                  </div>
                </div>
                <div class="flex justify-end items-center gap-3">
                  <button
                    type="submit"
                    :disabled="disable_submit == true"
                    :class="
                      this.disable_submit == true
                        ? 'bg-gray-200 text-black cursor-not-allowed'
                        : 'hover:bg-[#18469d] text-black border border-black cursor-pointer hover:text-white'
                    "
                    class="rounded-lg text-sm px-6 py-2"
                  >
                    Submit
                  </button>
                  <img
                    v-if="disable_submit"
                    src="@/assets/loading.gif"
                    alt="loading"
                    class="w-6 h-6 object-contain"
                  />
                </div>
                <!-- <div class="flex justify-end pb-4 mt-3">
                  <button
                    type="submit"
                    class="text-black border border-black rounded-lg text-sm px-10 py-2"
                  >
                    Submit
                  </button>
                </div> -->
              </form>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="popUp"
        class="fixed bg-primary bg-opacity-30 top-0 left-0 right-0 bottom-0 z-[100] flex items-center justify-center"
      >
        <div
          class="w-[40%] bg-white rounded-xl p-10 overflow-y-auto max-h-[600px]"
        >
          <div class="flex items-center justify-between">
            <h3 class="text-xl font-bold text-blues">Edit Class</h3>
            <img
              src="@/assets/newd/close.png"
              class="cursor-pointer"
              alt=""
              @click="this.popUp = false"
            />
          </div>

          <div
            class="w-full mt-4 flex flex-col p-6 relative border border-gray-100 rounded-2xl"
          >
            <div class="w-full">
              <form
                ref="ScheduleEvent"
                @submit.prevent="editEvents"
                class="flex flex-col gap-4 text-xs md:text-sm lg:text-base h-full"
              >
                <div
                  class="flex flex-col gap-2 w-full text-xs md:text-sm lg:text-base"
                >
                  <div class="w-full flex flex-col gap-2">
                    <label for="title" class="text-left">Title</label>
                    <input
                      id="meetingTitle"
                      type="text"
                      v-model="updatevalues.title"
                      class="border border-gray-100 rounded text-xs md:text-sm lg:text-base py-2 px-2"
                      required
                    />
                  </div>
                  <div class="w-full flex flex-col gap-2">
                    <label for="duedate" class="text-left">Start Time</label>
                    <input
                      id="meetingDate"
                      type="datetime-local"
                      v-model="updatevalues.start_date"
                      class="border border-gray-100 rounded text-xs md:text-sm lg:text-base py-2 px-2"
                      required
                    />
                  </div>

                  <div class="w-full flex flex-col gap-2">
                    <label for="duedate" class="text-left">End Time</label>
                    <input
                      id="meetingEnd"
                      type="datetime-local"
                      v-model="updatevalues.end_date"
                      class="border border-gray-100 rounded text-xs md:text-sm lg:text-base py-2 px-2"
                      required
                    />
                  </div>
                </div>
                <!-- <div class="flex flex-col w-full gap-2">
                  <label for="description" class="text-left">Description</label>
                  <textarea
                    id="description"
                    rows="3"
                    cols="10"
                    class="border border-gray-100 h-full rounded text-xs md:text-sm lg:text-base py-2 px-2"
                  />
                </div> -->
                <!-- <div class="flex flex-col w-full">
                  <label for="attachments" class="text-left">
                    Session duration
                  </label>
                  <input
                    id="duration"
                    type="number"
                    min="1"
                    v-model="updatevalues.duration"
                    class="border border-gray-100 rounded text-xs md:text-sm lg:text-base py-2 px-2"
                    required
                  />
                </div> -->

                <!-- <div class="flex flex-col w-full">
                  <label for="attachments" class="text-left">
                    Student limit
                  </label>
                  <input
                    id="studentLimit"
                    type="number"
                    min="1"
                    v-model="updatevalues.count"
                    class="border border-gray-100 rounded text-xs md:text-sm lg:text-base py-2 px-2"
                    required
                  />
                </div> -->

                <div class="flex flex-col w-full">
                  <label for="attachments" class="text-left">
                    Meeting URL
                  </label>
                  <div class="flex items-center gap-3 w-full">
                    <input
                      id="meetingUrledit"
                      type="text"
                      class="border border-gray-100 rounded text-xs md:text-sm lg:text-base py-2 px-2 w-[80%]"
                      v-model="updatevalues.url"
                      required
                    />
                    <div class="flex items-center gap-3 w-[20%]">
                      <button
                        type="button"
                        id="Editurl"
                        class="rounded-xl text-sm p-2 bg-blues hover:bg-[#18469d] cursor-pointer text-white"
                        @click="generateUrlEdit()"
                      >
                        Generate URL
                      </button>
                      <!-- <img
                        v-if="disable_submit"
                        src="@/assets/loading.gif"
                        alt="loading"
                        class="w-6 h-6 object-contain"
                      /> -->
                    </div>
                  </div>
                </div>
                <!-- <div class="flex justify-end items-center gap-3">
                  <button
                    type="submit"
                    :disabled="disable_submit == true"
                    :class="
                      this.disable_submit == true
                        ? 'bg-gray-200 text-black cursor-not-allowed'
                        : 'hover:bg-[#18469d] text-black border border-black cursor-pointer hover:text-white'
                    "
                    class="rounded-lg text-sm px-6 py-2"
                  >
                    Update
                  </button>
                  <img
                    v-if="disable_submit"
                    src="@/assets/loading.gif"
                    alt="loading"
                    class="w-6 h-6 object-contain"
                  />
                </div> -->
                <div class="flex justify-end pb-4 mt-3">
                  <button
                    type="submit"
                    class="text-black border border-black rounded-lg text-sm px-10 py-2"
                  >
                    Update
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="eventInfo"
        class="fixed bg-primary bg-opacity-30 top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center"
      >
        <div
          class="w-[40%] bg-white rounded-xl p-10 overflow-y-auto max-h-[600px]"
        >
          <div class="flex items-center justify-between">
            <h3 class="text-xl font-bold text-blues">
              {{ this.eventInfoData.title }}
            </h3>
            <img
              src="@/assets/newd/close.png"
              class="cursor-pointer"
              alt=""
              @click="eventInfo = false"
            />
          </div>

          <div
            class="w-full mt-4 flex flex-col p-6 relative border border-gray-100 rounded-2xl"
          >
            <div class="w-full">
              <form
                ref="ScheduleEvent"
                @submit.prevent="scheduledate"
                class="flex flex-col gap-4 text-xs md:text-sm lg:text-base h-full w-full"
              >
                <div
                  class="flex flex-col gap-2 w-full text-xs md:text-sm lg:text-base"
                >
                  <div class="w-full flex flex-col gap-2">
                    <label for="title" class="text-left font-bold">Title</label>
                    <p>{{ this.eventInfoData.title }}</p>
                    <!-- <input
                      id="meetingTitle"
                      type="text"
                      v-model="updatevalues.title"
                      class="border border-gray-100 rounded text-xs md:text-sm lg:text-base py-2 px-2"
                      required
                    /> -->
                  </div>
                  <div class="w-full flex flex-col gap-2">
                    <label for="duedate" class="text-left font-bold"
                      >Start Time</label
                    >
                    <p>
                      {{
                        eventInfoData.start &&
                        eventInfoData.start.format("DD/MM/YYYY")
                      }}
                      (
                      {{
                        eventInfoData.start && eventInfoData.start.formatTime()
                      }}
                      <span v-if="eventInfoData.start.getHours() >= 12"
                        >PM</span
                      >
                      <span v-else>AM</span>
                      )
                    </p>
                    <!-- <input
                      id="meetingDate"
                      type="datetime-local"
                      v-model="updatevalues.date" 
                      class="border border-gray-100 rounded text-xs md:text-sm lg:text-base py-2 px-2"
                      required
                    /> -->
                  </div>

                  <div class="w-full flex flex-col gap-2">
                    <label for="duedate" class="text-left font-bold"
                      >End Time</label
                    >
                    <p>
                      {{
                        eventInfoData.end &&
                        eventInfoData.end.format("DD/MM/YYYY")
                      }}
                      (
                      {{ eventInfoData.end && eventInfoData.end.formatTime() }}
                      <span v-if="eventInfoData.start.getHours() >= 12"
                        >PM</span
                      >
                      <span v-else>AM</span>
                      )
                    </p>
                    <!-- <input
                      id="meetingDate"
                      type="datetime-local"
                      v-model="updatevalues.date" 
                      class="border border-gray-100 rounded text-xs md:text-sm lg:text-base py-2 px-2"
                      required
                    /> -->
                  </div>
                </div>

                <div class="w-full flex flex-col gap-2">
                  <!-- <label for="attachments" class="text-left font-bold">
                    Event Details
                  </label> -->

                  <!-- <p></p> -->
                  <div class="w-auto flex flex-row">
                    <a
                      :href="eventInfoData.contentFull"
                      class="text-sm mt-1 bg-blues text-white px-3 py-2 rounded-xl text-sm"
                    >
                      Join Link
                    </a>
                  </div>
                  <!-- <input
                    id="duration"
                    type="number"
                    min="1" v-model="updatevalues.duration"
                    class="border border-gray-100 rounded text-xs md:text-sm lg:text-base py-2 px-2"
                    required
                  /> -->
                </div>

                <div class="flex justify-end pb-4 mt-3 gap-x-10">
                  <button
                    @click="
                      updatevalues = eventInfoData.event;
                      popUp = true;
                    "
                    class="rounded-lg text-sm px-6 py-2 hover:bg-[#18469d] text-black border border-black cursor-pointer hover:text-white"
                  >
                    Update
                  </button>
                  <button
                    @click="
                      titlepass = eventInfoData.title;
                      popupwindow = true;
                      idpass = eventInfoData.id;
                    "
                    class="rounded-lg text-sm px-6 py-2 hover:bg-[#18469d] text-black border border-black cursor-pointer hover:text-white"
                  >
                    Delete
                  </button>
                  <!-- <img
                    v-if="disable_submit"
                    src="@/assets/loading.gif"
                    alt="loading"
                    class="w-6 h-6 object-contain"
                  /> -->
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Instructor/Header.vue";
import SideBar from "@/components/Instructor/SideBar.vue";

import axios from "axios";
import { mapGetters } from "vuex";

import VueCal from "vue-cal";
import "vue-cal/dist/vuecal.css";

import FlashMessage from "@/components/FlashMessage.vue";
import ConfirmPopup from "@/components/ConfirmPopup.vue";

export default {
  components: {
    Header,
    SideBar,
    VueCal,
    ConfirmPopup,
    FlashMessage,
  },
  data() {
    return {
      courseInfo: null,
      calendarInfo: null,
      scheduleDetails: null,
      popUp: false,
      updatevalues: null,
      messages: {
        text: "",
        type: "null",
      },
      popupwindow: false,
      titlepass: "",
      idpass: "",
      addevent: false,
      activeView: "month",
      eventInfo: false,
      eventInfoData: "",
      values: [],
      generatedUrl: "",
      disable_submit: false,
      isContainAccessToken: localStorage.getItem("access_token"),
    };
  },

  created() {
    // this.getstudentdetails();
  },

  props: ["course_id"],

  computed: {
    ...mapGetters(["userInfo"]),

    minDate() {
      return new Date().subtractDays(5);
    },
  },

  async mounted() {
    await this.getinfos();

    if (localStorage.getItem("access_token")) {
      this.removeTokenIfNotValid();
    }
    // setTimeout(() => {
    //   let chatContainer = document.getElementById("chatContainer");
    //   console.log("Height::::=", chatContainer.offsetHeight);
    //   chatContainer.scrollTo({
    //     top: chatContainer.scrollHeight + 300,
    //     behavior: "smooth",
    //   });
    // }, 200)
  },

  methods: {
    removeTokenIfNotValid() {
      let convert_string = {
        subject: "test is access token valid",
        startDateTime: new Date().toISOString(),
        endDateTime: new Date().toISOString(),
      };

      axios
        .post(
          `https://graph.microsoft.com/v1.0/me/onlineMeetings`,
          convert_string,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
          }
        )
        .then((response) => {
          console.log(response.status, "response.status");
          if (response.status == 401) {
            console.log("token expired.");
          }
          //  if(response){
          //     // console.log("response", response.data.joinUrl);
          //     this.generatedUrl = response.data.joinUrl;
          //     // console.log(this.generatedUrl);
          //     // document.getElementById("meetingUrl").classList.remove("hidden");
          //     // document.getElementById("Editurl").classList.add("hidden");
          //  }
        })
        .catch((error) => {
          // console.log(error.status, "error.status::");
          if (error.status == 401) {
            // console.log("token expired.");
            if (localStorage.getItem("access_token")) {
              localStorage.removeItem("access_token");
            }
          }
          //  console.log(error, "error:::");
        });
    },

    onEventClick(event, e) {
      this.eventInfo = true;
      this.eventInfoData = event;
    },

    async getinfos() {
      let course_ids = parseInt(this.course_id);

      await axios
        .get(
          `${process.env.VUE_APP_API}/courses/?id=${course_ids}&Key=${this.userInfo.token_key}`
        )
        .then((Response) => {
          this.courseInfo = Response.data.data;
        });

      await axios
        .get(
          `${process.env.VUE_APP_API}/calendar/view/?course_data__id=${this.course_id}&Key=${this.userInfo.token_key}`
        )
        .then((Response) => {
          if (Object.keys(Response.data) == "error") {
            this.values = [];
            console.log("Null");
          } else {
            this.calendarInfo = Response.data.data;
            this.values = [];
            this.calendarInfo.forEach((element) => {
              // adding 30mits to the date
              let startdate = new Date(element.start_date);
              let enddate = new Date(startdate);

              enddate = new Date(
                enddate.setMinutes(startdate.getMinutes() + 30)
              );

              // enddate =
              //   [
              //     enddate.getFullYear(),
              //     enddate.getMonth() + 1,
              //     enddate.getDate(),
              //   ].join("-") +
              //   " " +
              //   [
              //     enddate.getHours(),
              //     enddate.getMinutes(),
              //     enddate.getSeconds(),
              //   ].join(":");

              // console.log(enddate,enddate.length,'end time before')
              // enddate = "2022-9-22 12:31:0"
              // console.log(enddate.length,'end time after')
              // reasigning the data to vue-cal event

              let tempvar = {
                start: element.start_date,
                end: element.end_date,
                title: element.title,
                class: "Progressive",
                contentFull: element.url,
                id: element.id,
                event: element,
              };
              this.values.push(tempvar); // pushing the database event to the vue-cal
            });
            console.log(this.values);
          }
        });
    },

    async deleteEvents(id) {
      // this.deleteEvents = true;
      await axios
        .delete(
          `${process.env.VUE_APP_API}/calendardeleted/${id}/?Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          // response;
          if (response.data.status == 200) {
            this.messages = {
              text: "Event Deleted successfully",
              type: "success",
            };
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
          }
        });
      // .finally(() => {
      //   this.deleteEvents = false;
      // });
      this.popupwindow = false;
      this.eventInfo = false;
      setTimeout(() => {
        this.messages = {
          text: "",
          type: "null",
        };
        this.getinfos();
      }, 1500);
    },

    async editEvents() {
      this.disable_submit = true;

      let updatedatas = {
        title: this.updatevalues.title,
        organization_id: this.updatevalues.organization_id,
        user: this.updatevalues.user,
        status: this.updatevalues.status,
        url: this.updatevalues.url,
        start_date: this.updatevalues.start_date,
        end_date: this.updatevalues.end_date,
        // count: this.updatevalues.count,
        duration: this.updatevalues.duration,
        // studentlist: null,
        course_data: parseInt(this.course_id),
      };
      await axios
        .put(
          `${process.env.VUE_APP_API}/calendarupdated/${this.updatevalues.id}/?Key=${this.userInfo.token_key}`,
          updatedatas
        )
        .then((response) => {
          this.disable_submit = false;
          if (response.data.status == 200) {
            this.messages = {
              text: "Event Updated successfully",
              type: "success",
            };
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
          }
        });
      // .finally(() => {
      //   this.disable_submit = false;
      // });
      setTimeout(async () => {
        this.messages = {
          text: "",
          type: "null",
        };
        this.popUp = false;
        this.updatevalues = null;
        this.eventInfo = false;
        await this.getinfos();
      }, 2500);
    },

    generateMeetingUrl() {
      const title = document.getElementById("meetingTitle").value;
      const start = document.getElementById("meetingDate").value;
      const end = document.getElementById("meetingEndDate").value;

      if (!title || !start || !end) {
        alert("Enter meeting title, start time and end time.");
        return;
      }

      const startUTC = new Date(start).toISOString();
      const endUTC = new Date(end).toISOString();

      const payload = {
        subject: title,
        startDateTime: startUTC,
        endDateTime: endUTC,
      };

      axios
        .post(`https://graph.microsoft.com/v1.0/me/onlineMeetings`, payload, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
          },
        })
        .then((response) => {
          if (response && response.data.joinUrl) {
            console.log("response", response.data.joinUrl);

            document.getElementById("meetingUrl").value = response.data.joinUrl;

            this.meetingUrl = response.data.joinUrl;
          }
        })
        .catch((error) => {
          console.log("Error generating URL:", error);
        });
    },

    generateUrl() {
      this.$msalInstance
        .loginPopup({
          scopes: ["user.read", "OnlineMeetings.ReadWrite", "offline_access"],
        })
        .then((res) => {
          if (res.accessToken) {
            // localStorage.setItem("access_token", JSON.stringify(res.accessToken));

            localStorage.setItem("access_token", res.accessToken);
            this.isContainAccessToken = res.accessToken;
          } else {
            console.log("not get access token");
          }
        });
    },

    generateUrlOldHave() {
      this.disable_submit = true;
      let title = document.getElementById("meetingTitle").value;
      let durations = document.getElementById("duration").value;
      let timedetails = document.getElementById("meetingDate").value;
      timedetails = timedetails.replaceAll("T", " ");
      let inputdatas = {
        topic: title,
        start_time: timedetails,
        agenda: title,
        duration: durations,
      };
      console.log(inputdatas);

      axios
        .post(
          `${process.env.VUE_APP_API}/zoom/?Key=${this.userInfo.token_key}`,
          inputdatas
        )
        .then((response) => {
          // console.log(response)
          this.generatedUrl = response.data.datzoom_join_urla;
          // console.log(this.generatedUrl)
          // document.getElementById("meetingUrl").classList.remove("hidden");
          // document.getElementById("urlGenerator").classList.add("hidden");
        })
        .finally(() => {
          this.disable_submit = false;
        });
    },

    generateUrlEdit() {
      // this.disable_submit = true;
      let title = this.updatevalues.title;
      // let durations = this.updatevalues.duration;

      let timedetails = this.updatevalues.start_date;
      timedetails = timedetails.replaceAll("T", " ");

      let timedetailsEnd = this.updatevalues.end_date;
      timedetailsEnd = timedetailsEnd.replaceAll("T", " ");

      // let inputdatas = {
      //   topic: title,
      //   start_time: timedetails,
      //   end_time: timedetailsEnd,
      //   agenda: title,
      // };
      // console.log(inputdatas);

      let convert_string = {
        subject: title,
        startDateTime: timedetails,
        endDateTime: timedetailsEnd,
      };

      axios
        .post(
          `https://graph.microsoft.com/v1.0/me/onlineMeetings`,
          convert_string,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
          }
        )
        .then((response) => {
          if (response) {
            // console.log("response", response.data.joinUrl);
            this.generatedUrl = response.data.joinUrl;
            // console.log(this.generatedUrl);
            // document.getElementById("meetingUrl").classList.remove("hidden");
            // document.getElementById("Editurl").classList.add("hidden");
          }
        })
        .catch((error) => {
          console.log(error, "error:::");
        });

      // axios
      //   .post(
      //     `${process.env.VUE_APP_API}/zoom/?Key=${this.userInfo.token_key}`,
      //     inputdatas
      //   )
      //   .then((response) => {
      //     // console.log(response)
      //     this.updatevalues.url = response.data.datzoom_join_urla;
      //     // console.log(this.generatedUrl)
      //     document.getElementById("meetingUrledit").classList.remove("hidden");
      //     document.getElementById("Editurl").classList.add("hidden");
      //   })
      //   .finally(() => {
      //     this.disable_submit = false;
      //   });
    },

    async scheduledate(el) {
      this.disable_submit = true;
      let Urls = el.target.elements.meetingUrl.value;

      let timedetails = el.target.elements.meetingDate.value;
      let timedetailsEnd = el.target.elements.meetingEndDate.value;

      // let studentlimit = el.target.elements.studentLimit.value;
      // let durations = el.target.elements.duration.value;
      let title = el.target.elements.meetingTitle.value;

      timedetails = timedetails.replaceAll("T", " ");
      timedetailsEnd = timedetailsEnd.replaceAll("T", " ");

      // "organization_id": this.courseInfo[0].organization_id,

      let inputdatas = {
        title: title,
        organization_id: this.userInfo.organizes_id,
        user: this.userInfo.user.id,
        status: true,
        url: Urls,
        start_date: timedetails,
        end_date: timedetailsEnd,
        // count: 0,
        // duration: durations,
        // studentlist: null,
        course_data: parseInt(this.course_id),
      };
      // console.log(inputdatas, "data first:::::");
      await axios
        .post(
          `${process.env.VUE_APP_API}/calendar_new/?Key=${this.userInfo.token_key}`,
          inputdatas
        )
        .then((response) => {
          this.disable_submit = false;
          this.scheduleDetails = response.data;
          if (this.scheduleDetails.status == 200) {
            this.messages = {
              text: "Event Added successfully",
              type: "success",
            };
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
          }
          this.$refs.ScheduleEvent.reset();
          this.getinfos();
          this.addevent = false;
          setTimeout(() => {
            this.generatedUrl = "";
            this.messages = {
              text: "",
              type: "null",
            };
          }, 1500);
        });
      // .finally(() => {
      //   this.disable_submit = false;
      // });
    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}

.vuecal--blue-theme {
  border-radius: 50px;
  background-color: white;
  position: relative;
  border: none !important;
}

.vuecal__event {
  color: #115e59;
  background-color: #f5f5f5;
  border: 1px dashed #ba0606;
  overflow: hidden;
}
.vuecal__cell-content {
  height: 180px;
}
.vuecal__event.Progressive {
  background-color: #0f766e;
  border-radius: 6px;
  border: 1px solid rgb(248, 247, 247);
  color: #fff;
}
.vuecal--short-events .vuecal__event-title {
  font-size: 0.8em;
  text-align: center;
}
.vuecal__cell-events {
  height: 180px;
  overflow: scroll;
  scrollbar-color: white transparent;
  cursor: pointer;
}

.vuecal__cell-content::-webkit-scrollbar {
  width: 8px;
}

.vuecal__cell-content::-webkit-scrollbar-thumb {
  background: gray;
  border-radius: 15px;
}

.vuecal__cell-content::-webkit-scrollbar-track {
  background: #fff;
}
</style>
